import { recordOf } from 'react-immutable-proptypes';
import FilterFieldType from './FilterFieldType';
export default recordOf({
  field: FilterFieldType.isRequired
});